export interface BatchTrcBooksOrderDataCreateRequest {
  traderCode: string
  buyBranch: string
  isOutputOrdered: boolean
  orderDateFrom: string
  orderDateTo: string
  memo: string
  batchType: string
}

export function BatchTrcBooksOrderDataCreateRequestToJSON(
  value: BatchTrcBooksOrderDataCreateRequest
): any {
  return {
    trader_code: value.traderCode,
    buy_branch: value.buyBranch,
    is_output_ordered: value.isOutputOrdered,
    order_date_from: value.orderDateFrom,
    order_date_to: value.orderDateTo,
    memo: value.memo,
    batch_type: value.batchType
  }
}
